import React from 'react';

import {
  Block,
  CardList,
  CardRow,
  Header,
  InlineRow,
  LeftColumn,
  RightColumn,
  Toolbar,
  Wrapper,
} from './style';

const rows = [...new Array(4)].map((_, index) => index);

const SkeletonCards = () => (
  <Wrapper>
    <Header>
      <Block width="120px" height="34px" />
      <Block width="120px" height="36px" />
    </Header>
    <Toolbar>
      <Block width="320px" height="36px" />
      <Block width="230px" height="36px" />
    </Toolbar>
    <CardList>
      {rows.map(row => (
        <CardRow key={row}>
          <LeftColumn>
            <Block width="160px" height="18px" />
            <div style={{ marginTop: 10 }}>
              <Block width="300px" height="14px" />
            </div>
            <div style={{ marginTop: 12 }}>
              <Block width="120px" height="24px" radius="999px" />
            </div>
          </LeftColumn>
          <RightColumn>
            <InlineRow>
              <Block width="120px" height="12px" />
              <Block width="36px" height="36px" radius="6px" />
            </InlineRow>
          </RightColumn>
        </CardRow>
      ))}
    </CardList>
  </Wrapper>
);

export default SkeletonCards;
